// import React, { useEffect, useState } from "react";
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import Typography from "@mui/material/Typography";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import FileUpload from "./fileUpload";
// import axios from "axios";
// import { styled } from "@mui/material/styles";

// const ScrollableAccordionDetails = styled(AccordionDetails)({
//   maxHeight: "200px",
//   overflowY: "auto",
// });

// const DocumentUpload = ({ onFileUrlChange, studentDoc }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [error, setError] = useState("");
//   const [documentDetails, setDocumentDetails] = useState({
//     aadhaar: [],
//     photos: [],
//     others: [],
//   });
//   const [selectedDocuments, setSelectedDocuments] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     axios
//       .get(
//         process.env.REACT_APP_JHS_DEVELOPMENT + "/student/getDocumentDetails"
//       )
//       .then((response) => {
//         setDocumentDetails(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//         setError("Failed to fetch document details.");
//         setLoading(false);
//       });
//   }, []);

//   const handleChange = (panel) => (event, isExpanded) => {
//     setExpanded(isExpanded ? panel : false);
//   };

//   const handleFileUrlChange = ({ document_id, fileUrl, base64Image }) => {
//     setSelectedDocuments((prevState) => {
//       const newDocuments = [...prevState, { document_id, base64: base64Image }];
//       onFileUrlChange(newDocuments);
//       return newDocuments;
//     });
//   };

//   const findBase64Image = (docId) => {
//     if (!studentDoc || studentDoc.length === 0) return "";
//     const foundDoc = studentDoc.find((doc) => doc.document_id === docId);
//     return foundDoc ? foundDoc.document_string : "";
//   };

//   return (
//     <>
//       {/* Css added */}
//       {loading && (
//         <div className="loading-overlay">Loading, please wait...</div>
//       )}
//       {error && <Typography color="error">{error}</Typography>}
     
//       <Accordion
//         style={{
//           border: expanded === "panel1" ? "2px solid #5F9ED9" : "1px solid #0A64A2",
//           borderRadius: "4px",
//           marginBottom: "4px",
//         }}
//         elevation={0} // This removes the shadow
//         expanded={expanded === "panel1"}
//         onChange={handleChange("panel1")}
//       >
//         <AccordionSummary
//           expandIcon={<ExpandMoreIcon />}
//           aria-controls="panel1bh-content"
//           id="panel1bh-header"
//         >
//           <Typography>Documents</Typography>
//         </AccordionSummary>
//         <ScrollableAccordionDetails>
//           <Typography>
//             {documentDetails.others
//               .filter((doc) => doc.document_name.includes("Student Aadhaar"))
//               .map((doc) => (
//                 <FileUpload
//                   key={doc.document_id}
//                   document_id={doc.document_id}
//                   label={doc.document_name}
//                   onFileUrlChange={handleFileUrlChange}
//                   base64Image={findBase64Image(doc.document_id)}
//                 />
//               ))}
//             <div
//               style={{
//                 border: "1px solid #0A64A2",
//                 paddingLeft: "8px",
//                 borderRadius: "3px",
//                 marginTop: "10px",
//                 marginBottom: "10px",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: "14px",
//                   marginTop: "-0.7rem",
//                   paddingLeft: "0.4rem",
//                   background: "#fff",
//                   width: "5rem",
//                 }}
//               >
//                 <b>
//                   Aadhaar<span style={{ color: "red" }}> *</span>
//                 </b>
//               </div>
//               {documentDetails.aadhaar.map((doc) => (
//                 <FileUpload
//                   key={doc.document_id}
//                   document_id={doc.document_id}
//                   label={doc.document_name}
//                   onFileUrlChange={handleFileUrlChange}
//                   base64Image={findBase64Image(doc.document_id)}
//                 />
//               ))}
//             </div>
//             {documentDetails.others
//               .filter((doc) => doc.document_name.includes("Student Photo"))
//               .map((doc) => (
//                 <FileUpload
//                   key={doc.document_id}
//                   document_id={doc.document_id}
//                   label={doc.document_name}
//                   onFileUrlChange={handleFileUrlChange}
//                   base64Image={findBase64Image(doc.document_id)}
//                 />
//               ))}
//             <div
//               style={{
//                 border: "1px solid #0A64A2",
//                 paddingLeft: "8px",
//                 borderRadius: "3px",
//                 marginTop: "10px",
//                 marginBottom: "10px",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: "14px",
//                   marginTop: "-0.7rem",
//                   paddingLeft: "0.4rem",
//                   background: "#fff",
//                   width: "3.8rem",
//                 }}
//               >
//                 <b>
//                   Photo<span style={{ color: "red" }}> *</span>
//                 </b>
//               </div>
//               {documentDetails.photos.map((doc) => (
//                 <FileUpload
//                   key={doc.document_id}
//                   document_id={doc.document_id}
//                   label={doc.document_name}
//                   onFileUrlChange={handleFileUrlChange}
//                   base64Image={findBase64Image(doc.document_id)}
//                 />
//               ))}
//             </div>
//             {documentDetails.others
//               .filter(
//                 (doc) =>
//                   !["Student Aadhaar", "Student Photo"].includes(
//                     doc.document_name
//                   )
//               )
//               .map((doc) => (
//                 <FileUpload
//                   key={doc.document_id}
//                   document_id={doc.document_id}
//                   label={doc.document_name}
//                   onFileUrlChange={handleFileUrlChange}
//                   base64Image={findBase64Image(doc.document_id)}
//                 />
//               ))}
//           </Typography>
//         </ScrollableAccordionDetails>
//       </Accordion>
//     </>
//   );
// };

// export default DocumentUpload;
import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileUpload from "./fileUpload";
import axios from "axios";
import { styled } from "@mui/material/styles";

const ScrollableAccordionDetails = styled(AccordionDetails)({
  maxHeight: "200px",
  overflowY: "auto",
});

const DocumentUpload = ({ setDocumentFlag1,
  setDocumentFlag2,
  setDocumentFlag3, setDocumentFlag4,
  setDocumentFlag5,
  setDocumentFlag6,
  setDocumentFlag7,
  setDocumentFlag8,
  setDocumentFlag9,
  setDocumentFlag10,
  setDocumentFlag11,
  onFileUrlChange, studentDoc }) => {
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState("");
  const [documentDetails, setDocumentDetails] = useState({
    aadhaar: [],
    photos: [],
    others: [],
  });
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [studentAadhaarId, setStudentAadhaarId] = useState(null);
  const [fatherAadhaarId, setFatherAadhaarId] = useState(null);
  const [motherAadhaarId, setMotherAadhaarId] = useState(null);
  const [guardianAadhaarId, setGuardianAadhaarId] = useState(null);

  const [studentPhotoId, setStudentPhotoId] = useState(null);
  const [fatherPhotoId, setFatherPhotoId] = useState(null);
  const [motherPhotoId, setMotherPhotoId] = useState(null);
  const [guardianPhotoId, setGuardianPhotoId] = useState(null);

  const [birthCertificateId, setBirthCertificateId] = useState(null);
  const [transferCertificateId, setTransferCertificateId] = useState(null);
  const [studentPassportId, setStudentPassportId] = useState(null);
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/student/getDocumentDetails"
      )
      .then((response) => {
        console.log("Full API Response:", response.data); // Debugging
  
        setDocumentDetails(response.data);
        setLoading(false);
  
        // Extract IDs from the correct arrays
        const studentAadhaar = response.data.others.find(doc => doc.document_name === "Student Aadhaar")?.document_id || null;
        const fatherAadhaar = response.data.aadhaar.find(doc => doc.document_name === "Father Aadhaar")?.document_id || null;
        const motherAadhaar = response.data.aadhaar.find(doc => doc.document_name === "Mother Aadhaar")?.document_id || null;
        const guardianAadhaar = response.data.aadhaar.find(doc => doc.document_name === "Guardian Aadhaar")?.document_id || null;
  
        const studentPhoto = response.data.others.find(doc => doc.document_name === "Student Photo")?.document_id || null;
        const fatherPhoto = response.data.photos.find(doc => doc.document_name === "Father Photo")?.document_id || null;
        const motherPhoto = response.data.photos.find(doc => doc.document_name === "Mother Photo")?.document_id || null;
        const guardianPhoto = response.data.photos.find(doc => doc.document_name === "Guardian Photo")?.document_id || null;
  
        const birthCertificate = response.data.others.find(doc => doc.document_name === "Birth Certificate")?.document_id || null;
        const transferCertificate = response.data.others.find(doc => doc.document_name === "Transfer Certificate")?.document_id || null;
        const studentPassport = response.data.others.find(doc => doc.document_name === "Student Passport")?.document_id || null;
  
        // Store them in state
        setStudentAadhaarId(studentAadhaar);
        setFatherAadhaarId(fatherAadhaar);
        setMotherAadhaarId(motherAadhaar);
        setGuardianAadhaarId(guardianAadhaar);
  
        setStudentPhotoId(studentPhoto);
        setFatherPhotoId(fatherPhoto);
        setMotherPhotoId(motherPhoto);
        setGuardianPhotoId(guardianPhoto);
  
        setBirthCertificateId(birthCertificate);
        setTransferCertificateId(transferCertificate);
        setStudentPassportId(studentPassport);
  
        console.log("Student Aadhaar ID:", studentAadhaar); // Should now print correct ID
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("Failed to fetch document details.");
        setLoading(false);
      });
  }, []);


  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleFileUrlChange = ({ document_id, fileUrl, base64Image }) => {

    if(document_id === studentAadhaarId){
      setDocumentFlag1(true);
    }
    else if(document_id === fatherPhotoId){
      setDocumentFlag2(true);
    
    }
    else if(document_id === motherPhotoId){
      setDocumentFlag3(true);
    } 
    else if(document_id === guardianPhotoId){
      setDocumentFlag4(true);
    } 
    else if(document_id === fatherAadhaarId){
      setDocumentFlag5(true);
    } 
    else if(document_id === motherAadhaarId){
      setDocumentFlag6(true);
    } 
    else if(document_id === guardianAadhaarId){
      setDocumentFlag7(true);
    } 
    else if(document_id === studentPhotoId){
      setDocumentFlag8(true);
    } 
    else if(document_id === birthCertificateId){
      setDocumentFlag9(true);
    } 
    else if(document_id === transferCertificateId){
      setDocumentFlag10(true);
    }
    else if(document_id === studentPassportId){
      setDocumentFlag11(true);
    }
    
    setSelectedDocuments((prevState) => {
      const newDocuments = [...prevState, { document_id, base64: base64Image }];
      onFileUrlChange(newDocuments);
      return newDocuments;
    });
  };

  const findBase64Image = (docId) => {
    if (!studentDoc || studentDoc.length === 0) return "";
    const foundDoc = studentDoc.find((doc) => doc.document_id === docId);
    return foundDoc ? foundDoc.document_string : "";
  };

  return (
    <>
    {/* Css added */}
      {loading && (
        <div className="loading-overlay">Loading, please wait...</div>
      )}
      {error && <Typography color="error">{error}</Typography>}
     
      <Accordion
        style={{
          border: expanded === "panel1" ? "2px solid #5F9ED9" : "1px solid #0A64A2",
          borderRadius: "4px",
          marginBottom: "4px",
        }}
        elevation={0} // This removes the shadow
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography>Documents</Typography>
        </AccordionSummary>
        <ScrollableAccordionDetails>
          <Typography>
            {documentDetails.others
              .filter((doc) => doc.document_name.includes("Student Aadhaar"))
              .map((doc) => (
                <FileUpload
                  key={doc.document_id}
                  document_id={doc.document_id}
                  label={doc.document_name}
                  onFileUrlChange={handleFileUrlChange}
                  base64Image={findBase64Image(doc.document_id)}
                />
              ))}
            <div
              style={{
                border: "1px solid #0A64A2",
                paddingLeft: "8px",
                borderRadius: "3px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  marginTop: "-0.7rem",
                  paddingLeft: "0.4rem",
                  background: "#fff",
                  width: "5rem",
                }}
              >
                <b>
                  Aadhaar<span style={{ color: "red" }}> *</span>
                </b>
              </div>
              {documentDetails.aadhaar.map((doc) => (
                <FileUpload
                  key={doc.document_id}
                  document_id={doc.document_id}
                  label={doc.document_name}
                  onFileUrlChange={handleFileUrlChange}
                  base64Image={findBase64Image(doc.document_id)}
                />
              ))}
            </div>
            {documentDetails.others
              .filter((doc) => doc.document_name.includes("Student Photo"))
              .map((doc) => (
                <FileUpload
                  key={doc.document_id}
                  document_id={doc.document_id}
                  label={doc.document_name}
                  onFileUrlChange={handleFileUrlChange}
                  base64Image={findBase64Image(doc.document_id)}
                />
              ))}
            <div
              style={{
                border: "1px solid #0A64A2",
                paddingLeft: "8px",
                borderRadius: "3px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  marginTop: "-0.7rem",
                  paddingLeft: "0.4rem",
                  background: "#fff",
                  width: "3.8rem",
                }}
              >
                <b>
                  Photo<span style={{ color: "red" }}> *</span>
                </b>
              </div>
              {documentDetails.photos.map((doc) => (
                <FileUpload
                  key={doc.document_id}
                  document_id={doc.document_id}
                  label={doc.document_name}
                  onFileUrlChange={handleFileUrlChange}
                  base64Image={findBase64Image(doc.document_id)}
                />
              ))}
            </div>
            {documentDetails.others
              .filter(
                (doc) =>
                  !["Student Aadhaar", "Student Photo"].includes(
                    doc.document_name
                  )
              )
              .map((doc) => (
                <FileUpload
                  key={doc.document_id}
                  document_id={doc.document_id}
                  label={doc.document_name}
                  onFileUrlChange={handleFileUrlChange}
                  base64Image={findBase64Image(doc.document_id)}
                />
              ))}
          </Typography>
        </ScrollableAccordionDetails>
      </Accordion>
    </>
  );
};

export default DocumentUpload;